export const API = process.env.REACT_APP_MANAGONE_API;

async function handle(res) {
  if (!res.ok) {
    let detail = null;
    try {
      const data = await res.json();
      detail = data.detail;
    } catch {
      /* ignore */
    }
    const err = new Error(typeof detail === "string" ? detail : `HTTP ${res.status}`);
    err.status = res.status;
    err.detail = detail;
    throw err;
  }
  return res.json();
}

export function apiGet(path) {
  return fetch(`${API}/api/public${path}`).then(handle);
}

export function apiPost(path, body) {
  return fetch(`${API}/api/public${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then(handle);
}
